// Note: Install & use 'classnames' library instead in future if need more conditional classes.
export function joinClasses(...classes: (string | undefined)[]): string | undefined {
    const filteredClasses = classes.filter(Boolean);
    if (filteredClasses.length === 0) {
        return undefined;
    }
    return filteredClasses.join(' ');
}